<template>
  <div>
    <right-panel class="float-right" id="sidebar-new-department" width="600px" icon="" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form @onAdminChanged="onAdminChanged" />
      </div>
    </right-panel>

    <!-- Begin : Inventory -->
    <template>
      <right-panel class="float-right" id="sidebar-department-inventory" width="1400px" icon="" @hidden="bulkUpdateRightPanelClosed">
        <BulkUpdateView v-if="selectedBox" @onUpdated="onBulkUpdated" />
      </right-panel>
    </template>
    <!-- End : Inventory -->

    <div class="ds-card">
      <div class="ds-card--title justify-content-between">
        <span>
          <i class="iconoir-center-align align-middle mr-3" style="color: #383A55; font-size: 1.5rem !important;"></i>
          {{ $t("department.organization-departments") }}
        </span>

        <div v-if="recommendationAvailable" class="d-flex align-items-center float-right">
          <div class="d-flex align-items-center">
            <label class="switch-label">{{ $t("common.recommendations") }}</label>
            <b-form-checkbox v-model="showRecommendationBoxes" name="check-button" switch class="switch"></b-form-checkbox>
          </div>
        </div>
      </div>
      <div>
        <div class="search2  mb-4" style=" width: 18.50rem;">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input class="search2--input" type="text" :placeholder="$t('common.search')" v-model="nameFilter" />
        </div>
      </div>

      <content-loading v-if="isLoading" />
      <div v-else-if="pagination" class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
        <div v-for="item in pagination.docs" :key="item._id" :id="'popover-target-' + item._id" class="ds-card--item" :class="selectedBoxStyle(item)" @click="selectBox(item)">
          <div class="actions d-flex justify-content-end p-2" style="top:0">
            <div class="action" @click="redirectToRelatedFiles(item)" v-on:click.stop v-b-tooltip.hover :title="$t('file-manager.view-related-files')">
              <i class="iconoir-page"></i>
            </div>
          </div>
          <div class="text">{{ item.name | translate }}</div>
          <div class="actions d-flex justify-content-center">
            <div class="action" v-if="hasRemovePermission" @click="deleteById(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.delete')">
              <i class="iconoir-trash"></i>
            </div>
            <div class="action" v-if="hasUpdatePermission" @click="markAsComplete(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.completed')">
              <i :class="item.completed ? 'iconoir-check-circle' : 'iconoir-circle'"></i>
            </div>
            <div class="action" @click="edit(item)" v-on:click.stop v-b-toggle="'sidebar-edit-organization-department'" v-b-tooltip.hover :title="$t('common.edit')">
              <i class="iconoir-edit-pencil"></i>
            </div>
            <div class="action" @click="showInventoryPanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('inventory.filter.inventory-features')">
              <i class="iconoir-network-right"></i>
            </div>
          </div>

          <b-popover :target="'popover-target-' + item._id" triggers="hover" placement="bottom" variant="secondary">
            <template #title> {{ $t("department.admins") }}</template>
            <table>
              <tr v-for="admin in item.admins" :key="'department-admin' + admin._id">
                <td><letter-avatar :name="admin.account.name" :image="admin.account.avatar" variant="secondary" /></td>
                <td class="text-center">{{ admin.account.name }}</td>
              </tr>
              <tr v-if="!item.admins || item.admins.length < 1">
                <span>
                  <b>
                    {{ $t("department.no-admin") }}
                  </b>
                </span>
              </tr>
            </table>
          </b-popover>
        </div>

        <div class="ds-card--item2" v-b-toggle="'sidebar-new-department'">
          <i class="iconoir-plus" style="font-size: 1.75rem;"></i>
        </div>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
      <recommendation-boxes
        :show="showRecommendationBoxes"
        level="department"
        :libraryScopedState="libraryScopedState"
        organizationScopedState="organizationDepartment"
        @onAccepted="paginate"
        @copyToForm="copyToForm"
        :title="$t('department.recommendations')"
      />
    </div>
  </div>
</template>

<script>
import BulkUpdateView from "@modules/inventory/component/bulk-update/bulk-update-view";
import Form from "../../department/organization-department-form";
import RecommendationBoxes from "./recommendation-boxes";

export default {
  components: { Form, RecommendationBoxes, BulkUpdateView },
  data() {
    return {
      request: {
        options: { page: 1, limit: 17, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      libraryScopedState: "department",
      showRecommendationBoxes: undefined,
    };
  },
  computed: {
    recommendationAvailable() {
      const loading = this.$store.getters[`${this.libraryScopedState}/isLoading`];
      const recommendations = this.$store.getters[`${this.libraryScopedState}/recommendations`];

      if (loading) {
        return false;
      }
      if (recommendations && recommendations.docs && recommendations.docs.length > 0) {
        return true;
      }
      return false;
    },
    pagination() {
      return this.$store.getters["organizationDepartment/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDepartment/isLoading"];
    },

    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },
    selectedBox() {
      return this.$store.getters["entityBoxes/department"];
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    async nameFilter(n, o) {
      this.debounce(() => this.handleNameFilterChanged(n, o));
    },
  },
  mounted() {},
  methods: {
    async handleNameFilterChanged(n, o) {
      this.$store.commit("entityBoxes/clear");
      this.$store.commit("organizationDepartment/selectedEntity", undefined);

      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };

        const selectedDepartment = this.$store.getters["entityBoxes/department"];
        if (selectedDepartment) {
          await this.selectBox(selectedDepartment);
        }
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    onBulkUpdated() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-department-inventory");
    },
    redirectToRelatedFiles(item) {
      const url = this.currentProduct ? `/${this.currentProduct.toLowerCase()}/file-manager` : "/organization/file-manager";
      this.$router.push({ path: url, query: { department: item._id, departmentName: item.name?.[this.currentLanguage] } });
    },

    showInventoryPanel(item) {
      this.$store.commit("entityBoxes/department", item);
      this.$store.commit("organizationDepartment/selectedEntity", item);

      this.$store.commit("inventoryFilter/clear");
      this.$store.commit("inventoryFilter/department", item);

      this.$root.$emit("bv::toggle::collapse", "sidebar-department-inventory");
    },

    selectedBoxStyle(item) {
      let style = "";
      if (this.selectedBox?._id == item._id) {
        style = "bg-main text-white";
      } else if (item.completed) {
        style += " completed";
      }
      return style;
    },

    async paginate() {
      await this.$store.dispatch("organizationDepartment/paginate", this.request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDepartment/delete", item._id);
        this.paginate();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    async markAsComplete(item) {
      try {
        await this.$store.dispatch("organizationDepartment/markAsComplete", item._id);
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    edit(item) {
      this.$store.commit("organizationDepartment/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-department");
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.commit("organizationDepartment/editedEntity");
      this.$store.commit("organizationDepartment/copingEntity");
      // this.$store.dispatch("organizationDepartment/resetForm");
    },
    bulkUpdateRightPanelClosed() {
      this.$store.commit("inventoryFilter/clear");
    },

    async selectBox(item) {
      return this.$store.dispatch("entityBoxes/selectDepartment", item);
    },

    async onAdminChanged() {
      const selectedDepartment = this.$store.getters["entityBoxes/department"];

      await this.selectBox(selectedDepartment); //ikikere çağırılmasının nedeni toggle yapmak
      await this.selectBox(selectedDepartment);
    },
    copyToForm(item) {
      this.$store.commit(`organizationDepartment/copingEntity`, { ...item, libraryItem: item, _id: undefined });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-department");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../organization-entities-view.scss");
</style>
